import { api } from '../../core/network/api';

export interface MobData {
  type: string; name: string;
  hp: number; attack: number; defense: number;
  cash: number; exp: number; level: number;
  /** Balance archetype behind this family-styled unit (drives art fallbacks). */
  archetype?: string;
  /** Marks a named, rare, top-tier world boss — undefined for ordinary mobs. */
  kind?: 'mythic';
}
export interface Tile {
  type: string;
  mob?: MobData;
  districtId?: string;
  districtName?: string;
}
/** Ward ground metadata — stronghold hex (col/row) lets the client
 *  voronoi-partition the whole map into clan territories. */
export interface DistrictInfo {
  id: string; name: string; family: string;
  tier: number; unlockLevel: number; locked: boolean;
  owner: 'you' | 'rival' | 'neutral';
  col: number; row: number;
  /** Your ward, raiders at the gate: break the siege before siegeEndsAt or lose it. */
  underSiege?: boolean;
  siegeEndsAt?: string | null;
}
export interface MapData { cols: number; rows: number; seed: number; tiles: Tile[][]; districts: DistrictInfo[] }
export interface Nerve {
  current: number;
  max: number;
  /** Fractional regen anchor + rate for the client-side countdown. */
  regen?: { exact: number; perMin: number };
}
export interface Position { col: number; row: number; nerve: Nerve; exploredCells: string[] }
export interface MoveResult { col: number; row: number; cost: number; nerve: Nerve; exploredCells: string[] }

export const fetchMap = () => api.get<MapData>('/map/tiles');
export const fetchPosition = () => api.get<Position>('/map/position');
export const moveTo = (col: number, row: number) => api.post<MoveResult>('/map/move', { col, row });

export interface LootDrop {
  id: string;
  name: string;
  rarity: 'COMMON' | 'UNCOMMON' | 'RARE' | 'EPIC' | 'LEGENDARY';
  type: 'WEAPON' | 'HELMET' | 'ARMOR' | 'BOOTS' | 'RING' | 'AMULET';
}
